import { createFileRoute } from '@tanstack/react-router'
import { RiderAppGate } from '@/components/rider/RiderAppGate'
import { RiderPage } from '@/components/rider/RiderPage'

function RiderRoutePage() {
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden bg-background">
      <RiderAppGate>
        <RiderPage />
      </RiderAppGate>
    </div>
  )
}

export const Route = createFileRoute('/admin/rider')({
  component: RiderRoutePage,
})
